import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/standard-lab-procedures/t3";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	t3: {
		id: "form.t3",
		defaultMessage: "T3"
	},
	value: {
		id: "form.t3.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "t3",
	value: {
		title: messages.t3,
		validator,
		fieldset,
		isImportant: true
	}
};
